export default "__VITE_ASSET__BD6aUH7M__"